import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function GlobalForwarding() {
    return (
        <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Global Freight Forwarding</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>DELTRANS GLOBAL has a broad organization of contacts and phenomenal collaboration's with different worldwide delivery organizations. Our clients get the best transportation rates and cruising valuable open doors. Our subject matter experts, whom are situated in both huge and more modest worldwide ports, will deal with everything connecting with your cargoes. Do you have to move apparatus, out of measure freight, veterinary items, refrigerated or frozen (dope) freight or risky merchandise? This is a walk in the park for DELTRANS GLOBAL. Is it safe to say that you are searching for an expert delivery forwarder who can sort out your vehicle including all going with documentation? Then, at that point, DELTRANS GLOBAL is glad to finish the work.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default GlobalForwarding